import { render, staticRenderFns } from "./shipperInvoiceList.vue?vue&type=template&id=50bf9de2"
import script from "./shipperInvoiceList.vue?vue&type=script&lang=js"
export * from "./shipperInvoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports